document.addEventListener('DOMContentLoaded', function () {
  // Find all content slider instances
  const sliders = document.querySelectorAll('[id^="content-slider-"]')

  sliders.forEach((slider) => {
    if (!slider) return

    // Get the section ID from the slider ID
    const sectionId = slider.id.replace('content-slider-', '')
    const shopifySection = document.getElementById(`shopify-section-${sectionId}`)

    if (!shopifySection) return

    // Find the element with data attributes (the gradient wrapper)
    const dataContainer = shopifySection.querySelector('[data-slides-per-view-desktop]')

    if (!dataContainer) {
      console.error('Could not find data attributes container')
      return
    }

    // Get settings from data attributes or use defaults
    const showNavigation = dataContainer.dataset.showNavigation !== 'false'
    const autoplay = dataContainer.dataset.autoplay === 'true'
    const autoplayDelay = parseInt(dataContainer.dataset.autoplayDelay) || 5000
    const slidesPerViewDesktop = parseFloat(dataContainer.dataset.slidesPerViewDesktop) || 3
    const slidesPerViewMobile = parseFloat(dataContainer.dataset.slidesPerViewMobile) || 1.2
    const spaceBetween = parseInt(dataContainer.dataset.spaceBetween) || 20

    // Find pagination element
    const paginationEl = shopifySection.querySelector('.swiper-pagination')

    // Initialize Swiper
    // eslint-disable-next-line no-undef, no-unused-vars
    const contentSwiper = new Swiper(`#${slider.id}`, {
      spaceBetween,
      slidesPerView: slidesPerViewMobile,
      grabCursor: true,
      observer: true,
      observeParents: true,
      resizeObserver: true,
      centeredSlides: true,
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide'
      },
      breakpoints: {
        320: {
          slidesPerView: slidesPerViewMobile,
          spaceBetween: spaceBetween / 2,
          centeredSlides: true,
          slidesOffsetAfter: 0
        },
        750: {
          slidesPerView: slidesPerViewDesktop - 1,
          spaceBetween,
          centeredSlides: false,
          slidesOffsetAfter: window.innerWidth * 0.5
        },
        1440: {
          slidesPerView: slidesPerViewDesktop,
          spaceBetween,
          centeredSlides: false,
          slidesOffsetAfter: window.innerWidth * 0.5
        }
      },
      navigation: showNavigation
        ? {
            nextEl: shopifySection.querySelector('.swiper-button-next'),
            prevEl: shopifySection.querySelector('.swiper-button-prev')
          }
        : false,
      pagination: paginationEl
        ? {
            el: paginationEl,
            clickable: true,
            dynamicBullets: false,
            type: 'bullets'
          }
        : false,
      autoplay: autoplay
        ? {
            delay: autoplayDelay,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          }
        : false,
      loop: false,
      watchOverflow: true
    })
  })
})
